
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink, RefreshCw } from "lucide-react";
import EnhancedMobileOptimizedHero from "@/components/homepage/EnhancedMobileOptimizedHero";

const HeroPreview = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleViewLive = () => {
    window.open('/', '_blank');
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Live Preview</CardTitle>
            <p className="text-sm text-muted-foreground">
              Preview how your hero section looks with current settings
            </p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={handleRefresh} className="gap-2">
              <RefreshCw className="h-4 w-4" />
              Refresh
            </Button>
            <Button variant="outline" size="sm" onClick={handleViewLive} className="gap-2">
              <ExternalLink className="h-4 w-4" />
              View Live
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Badge variant="secondary">Preview Mode</Badge>
              <span className="text-sm text-muted-foreground">
                This preview uses live data from your database
              </span>
            </div>
            
            <div className="border rounded-lg overflow-hidden bg-background">
              <div className="transform scale-50 origin-top-left w-[200%] h-[100vh] overflow-hidden">
                <EnhancedMobileOptimizedHero />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default HeroPreview;
